import { Popup, SelectBox } from "devextreme-react";
import { PopupRef, Position } from "devextreme-react/popup";
import { FormEvent, useRef } from "react";
import { useAppDispatch } from "@hooks/useAppDispatch";
import { useAppSelector } from "@hooks/useAppSelector";
import { uqActions } from "@redux/uq/uq-slice";
import { CalculateGrid } from "@redux/uq/uq-actions";
import CustomButton from "@components/CustomButton";
import { closePopup } from "@helpers/DxHelper";
import NumberBoxWrapper from "@/components/NumberBoxWrapper";
import { NumberBoxRef } from "devextreme-react/cjs/number-box";

type Props = { popupRef: React.RefObject<PopupRef>; gridSet: any };

export default function PrepopulatePopup({ popupRef, gridSet }: Props) {
  const { updateCell, indexShift } = useAppSelector((state) => state.uq);
  const dispatch = useAppDispatch();
  const valueInputRef = useRef<NumberBoxRef>(null);

  if (!updateCell) return null;

  const ageTo100 = gridSet.length - updateCell?.rowIndex - indexShift;

  function saveHandler(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const valueToPopulate = Number(e.target[0].value);
    let numberOfCellsToPopulate = Number(e.target[2].value);

    if (e.target[2].value === "All") {
      numberOfCellsToPopulate = ageTo100;
    }

    const newGrid = structuredClone(gridSet);
    const startIndex = updateCell.rowIndex + indexShift;

    for (let i = 0; i < numberOfCellsToPopulate; i++) {
      newGrid[startIndex + i][updateCell.col] = {
        ...newGrid[startIndex + i][updateCell.col],
        value: valueToPopulate,
        manualChange: true,
      };
    }

    if (
      numberOfCellsToPopulate !== ageTo100 &&
      newGrid[startIndex + numberOfCellsToPopulate][updateCell.col] &&
      e.target[2].value !== "All"
    ) {
      newGrid[startIndex + numberOfCellsToPopulate][updateCell.col] = {
        ...newGrid[startIndex + numberOfCellsToPopulate][updateCell.col],
        value: 0,
        manualChange: true,
      };
    }

    newGrid[startIndex][updateCell.col] = {
      ...newGrid[startIndex][updateCell.col],
      manualChange: true,
    };

    dispatch(CalculateGrid(updateCell?.row, newGrid));
    dispatch(uqActions.setIsModified(true));

    closePopup(popupRef);
  }

  const focusNumberInput = () => {
    if (valueInputRef?.current) {
      setTimeout(() => {
        valueInputRef?.current?.instance().focus();
      }, 100);
    }
  };

  return (
    <Popup
      onShown={focusNumberInput}
      width={210}
      height="fit"
      ref={popupRef}
      hideOnOutsideClick={true}
      showTitle={false}
    >
      <Position
        at="top"
        my="bottom"
        of={updateCell.id ? `#${updateCell.id}` : undefined}
        collision="fit flip"
      />
      <form onSubmit={saveHandler}>
        <div className="flex flex-col gap-6">
          <NumberBoxWrapper
            stylingMode="outlined"
            format="$ #,##0.##"
            label="Value"
            width={164}
            ref={valueInputRef}
          />
          <SelectBox
            stylingMode="outlined"
            defaultValue={1}
            label="No. of cells"
            searchEnabled
            searchTimeout={100}
            items={[
              "All",
              ...Array(ageTo100)
                .fill(0)
                .map((item, i) => item + i + 1),
            ]}
            width={164}
          />
        </div>
        <CustomButton className="mt-7 h-11 w-full" text="Prepopulate" variant="primary" />
      </form>
    </Popup>
  );
}
